import * as React from 'react';
import { VtxButton, VtxIcon, VtxModal } from '@vertexinc/vtx-ui-react-component-library';
import BusyDialogProps from './BusyDialogProps.interface';
import Logging from '../Logging/Logging';
import './busy.scss';

const bodyStyle = {
  backgroundColor: 'white',
};

const BusyDialog = ({
  busyMessage,
  isOpen,
  onClose = null,
}: BusyDialogProps): JSX.Element => {
  const onCloseBusy = (): void => {
    if (onClose) {
      Logging.Info('Busy Close');
      onClose();
    }
  };

  return (
    <div>
      <VtxModal
        visible={isOpen}
        onCancel={(): void => onCloseBusy()}
        bodyStyle={bodyStyle}
        width="600px"
        footer={null}
        closable={false}
      >
        <div className="busyContainer">
          <div className="busyLeft">
            <img src="/images/loading-animation.svg" alt="loading" className="waitingImage" />
            <span>{busyMessage}</span>
          </div>
          <div className="busyRight">
            {
              onClose
                && (
                  <VtxButton
                    id="busyCloseButton"
                    type="link"
                    onClick={(): void => onCloseBusy()}
                    icon={<VtxIcon type="close-small" fontSize={12} />}
                  />
                )
            }
          </div>
        </div>
      </VtxModal>
    </div>
  );
};

export default BusyDialog;
